export default __webpack_public_path__ + "static/media/exit-load-icon.43a79628.svg";